import {
  ButtonLoadingEllipsis,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { useTrackActions } from "@/utils/hooks/useTracking";
import { formatMoney } from "@/utils/StringUtils";
import { AnalyticsTrackingEvent } from "@brandclub/common-ui";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";
import { useLoadingCheckoutIntent } from "../../hooks/useLoadingCheckoutIntent";
import { CheckoutIntent } from "../../types/CheckoutIntent";
import { useEffect, useState } from "react";

export const SubmitCheckoutButton = ({
  showTotal = false,
  text = "Submit my order",
}: {
  text?: string;
  showTotal?: boolean;
}) => {
  const [state, send] = useCheckoutUI();
  const [trackAction] = useTrackActions();
  // @ts-ignore
  const { checkoutIntent } = state.context as {
    checkoutIntent: CheckoutIntent;
  };
  const checkoutIntentId = checkoutIntent?.checkoutIntentId;
  const { loading } = useLoadingCheckoutIntent();
  const { items } = useCheckoutCartInfo();
  const [canPlaceOrder, setCanPlaceOrder] = useState(false);

  const showEnabledSubmitButton =
    state.value === "ready_to_checkout" || state.value === "checking_out";

  const checkingOut = state.value === "checking_out";

  useEffect(() => {
    if (
      checkoutIntent?.shippingAddress?.address1 &&
      checkoutIntent?.stripePaymentMethod?.id &&
      checkoutIntent?.stripePaymentIntent?.id &&
      checkoutIntent?.retailerConnection?.username &&
      state.value === "ready_to_checkout"
    ) {
      setCanPlaceOrder(true);
    } else {
      setCanPlaceOrder(false);
    }
  }, [checkoutIntent, state.value]);

  const handleSubmitClick = () => {
    trackAction(AnalyticsTrackingEvent.CHECKOUT_ORDER_SUBMIT, {
      checkoutIntentId: checkoutIntentId,
      checkoutItems: items || [],
      estimatedTotal: checkoutIntent?.estimatedOrderSummary?.total,
      checkoutPhase: "pre_submission",
    });
    send({ type: "SUBMIT_CHECKOUT" });
  };

  if (loading) {
    return null;
  }

  return (
    <SolidButton
      disableMaxWidth
      disabled={(!canPlaceOrder && !checkingOut) || !showEnabledSubmitButton}
      onClick={checkingOut ? undefined : handleSubmitClick}
      sx={(theme) => ({
        height: "50px",
        maxWidth: "unset",
        width: "100%",
        [theme.breakpoints.down("md")]: {
          height: "44px",
        },
      })}
    >
      {state.value === "checking_out" || loading ? (
        <ButtonLoadingEllipsis baseFontSize={16} />
      ) : (
        <>
          {text}
          {showTotal && (
            <>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              {formatMoney(checkoutIntent?.estimatedOrderSummary?.total!)}
            </>
          )}
        </>
      )}
    </SolidButton>
  );
};
